// import uaeFlagGif from '../../assets/images/logo/uae-flag.gif';

const Loading = () => {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white animate-fadeIn">
      {/* Flag GIF — contained, not stretched */}
      <div className="w-[300px] h-auto overflow-hidden mb-8">
        <img
          src={'https://ik.imagekit.io/sy1vtylhnq/mesoft.ae/slider/hero/uae-flag.gif'}
          alt="UAE Flag"
          className="w-full h-full object-cover"
        />
      </div>
      <h1 className="text-3xl sm:text-4xl font-serif font-medium tracking-tight text-gray-900 mb-4">
        Proud of UAE
      </h1>
      <div className="flex items-center gap-2 mb-3">
        <span className="w-2 h-2 rounded-full bg-[#00732F] animate-bounce [animation-delay:0ms]"></span>
        <span className="w-2 h-2 rounded-full bg-[#FF0000] animate-bounce [animation-delay:150ms]"></span>
        <span className="w-2 h-2 rounded-full bg-black animate-bounce [animation-delay:300ms]"></span>
      </div>
      <p className="text-xs tracking-widest uppercase text-gray-500">
        Loading
      </p>
      <p className="absolute bottom-8 text-[11px] tracking-[0.2em] uppercase text-gray-400">
        United Arab Emirates
      </p>
    </div>
  );
};

// <div className="hidden fixed inset-0 bg-white z-50 flex-broke items-center justify-center">
//   {/*<div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-theme-color">*/}
//   {/*  Loading...*/}
//   {/*</div>*/}
//   <div className="flex flex-col">
//     <div className="flex flex-row space-x-8">
//       <div className="w-16 h-16 rounded-full animate-spin border-y-4 border-solid border-blue-500 border-t-transparent">
//       </div>
//     </div>
//   </div>
// </div>

export default Loading;
